import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSolverSummarySizeM from './IconSolverSummary_size_m';

const props: CreateIconArguments = {
  l: IconSolverSummarySizeM,
  m: IconSolverSummarySizeM,
  s: IconSolverSummarySizeM,
  xs: IconSolverSummarySizeM,
  name: 'IconSolverSummary',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
